import React from 'react';
import { BaseButton } from '../../../../../BaseComponents';
import { AcceptCheckinRules, useStartCheckIn } from '@features/start-check-in';
import { useTranslation } from 'react-i18next';

interface Props {
	buttonClassName?: string;
}

const StartCheckInButton: React.FC<Props> = ({ buttonClassName }) => {
	const { t } = useTranslation('OrderCard');

	const {
		loading,
		isCheckinAvailable,
		isRulesModalOpen,
		closeRulesModal,
		checkinRules,
		acceptRules,
		goToCheckin
	} = useStartCheckIn();

	if (!isCheckinAvailable) {
		return null;
	}

	return (
		<>
			<BaseButton className={buttonClassName} isLoading={loading} onClick={goToCheckin}>
				{t('Check-in')}
			</BaseButton>

			{checkinRules && (
				<AcceptCheckinRules
					isOpen={isRulesModalOpen}
					onClose={closeRulesModal}
					rules={checkinRules}
					onSubmit={acceptRules}
				/>
			)}
		</>
	);
};

export default StartCheckInButton;
